const content = [
    // 第一章
    // 章标题
    {
      key: 'section1',
      type: "title",
      category: 1, // *必填* 分类 1：章头 2：节头 3：小标题 ...
      shortText: "第<span style=\"font-family:'Times New Roman'\">1<\/span>章", // 小标题文本，有值的时候展示 例如：第一章、第一节等
      text: '文旌课堂简介', // *必填* 标题文本内容
      textStyle: {
        // fontFamily: 'Arial', // 字体，本地配置的字体
        // fontSize: 32, // 文字大小  默认：26
        // lineHeight: 40, // 行高  默认：46
        // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
        // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        // color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
        // backgroundImage: require("@/assets/images/bookContent/top_bg.png") // 背景图片  默认：无
      }
    },
    // 正文
    {
      key: 'section1.1', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section1.1.1', // *必填* 唯一标识
          category: 'link', // *必填* 内容类型 text：文本 
          text: '文旌课堂', // *必填* 文本内容
          link: 'https://www.wenjingketang.com/',
          // linkIcon: require("@/assets/images/bookContent/bubble-icon-baidu.png"),
          textStyle: {
            
          },
        },
        {
          key: 'section1.1.2', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '是一款为在校师生量身打造的数字化教育平台。平台综合了数字教材服务、图书服务、教学服务、考试服务、', // *必填* 文本内容
          textStyle: {
          },
        },
        {
          key: 'section1.1.3', // *必填* 唯一标识
          category: 'popover', // *必填* 内容类型 text：文本 
          text: '网络学习', // *必填* 文本内容
          popTitle: '', // 气泡的标题 气泡的标题与内容至少需要存在一个
          popText: '以互联网为载体的学习方式的统称。', // 气泡的内容
          popLink: 'https://www.zgbk.com/ecph/words?SiteID=1&ID=138122&Type=bkzyb&SubID=42862', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
          textStyle: {
            
          },
        },
        {
          key: 'section1.1.4', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '服务等多项服务（见图', // *必填* 文本内容
          textStyle: {
          },
        },
        {
          key: 'section1.1.5', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '1', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Times New Roman', // 字体，本地配置的字体
          },
        },
        {
          key: 'section1.1.6', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '），能够全面满足学生、教师、学校的学习、教学和管理需求。', // *必填* 文本内容
          textStyle: {
          },
        },
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        // color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 特殊内容
    {
      key: 'section1.2', // *必填* 唯一标识
      type: 'special', // *必填* 类型：特殊内容
      category: 'introduction', // 交互类型 introduction：介绍功能
      cover: require('@/assets/images/bookExample/action-back.png'), // 整体背景图
      title: "图<span style=\"font-family:'Times New Roman'\">1<\/span>&nbsp;&nbsp;&nbsp;&nbsp;文旌课堂五大服务", // 标题
      titleStyle: {},
      content: [
        // 动态图片
        {
          key: 'special1.1',
          title: '图书服务',
          details: ['选书购书', '配套资料', '样书申请', '出版合作'],
          info: '数千种高等教育、职业教育精品教材和考试图书，配套五星级教学资料包'
        },
        {
          key: 'special1.2',
          title: '数字教材',
          details: ['教材征订', '教材共建', '出版合作'],
          info: '提供优质、专业的数字教材策划服务'
        },
        {
          key: 'special1.3',
          title: '教学服务',
          details: ['在线学习', '课堂签到', '作业考试', '成绩管理'],
          info: '随书附赠的在线教学平台，开启信息化教学新模式'
        },
        {
          key: 'special1.4',
          title: '考试服务',
          details: ['考试资讯', '考试平台', '联考合作'],
          info: '聚焦升学考试，精准备考，高效教学'
        },
        {
          key: 'special1.5',
          title: '网络学习',
          details: ['资讯信息', '在线题库', '网络课程'],
          info: '提供丰富的学习资料，满足学生个性化学习需求'
        },
      ],
    },
    // 特殊正文 -- 重点
    {
      key: 'section1.3', // *必填* 唯一标识
      type: 'text-special', // *必填* 类型：正文
      top_img: require("@/assets/images/books/bookExample/block-top-bg.png"), // 顶部的图片样式
      left_img: require("@/assets/images/books/bookExample/special-icon.png"), // 左侧的图片样式
      content: [
        // 整体内容 相当于p标签列表
        {
          key: 'section1.3.1', // *必填* 唯一标识
          content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
              key: 'section1.3.1.1', // *必填* 唯一标识
              category: 'text', // *必填* 内容类型 text：文本 
              text: '文旌课堂的宗旨是：只专注于做好一件事——为教学服务。', // *必填* 文本内容
              textStyle: {
              },
            },
          ],
          textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
          },
        },
        {
          key: 'section1.3.2', // *必填* 唯一标识
          content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
              key: 'section1.3.2.1', // *必填* 唯一标识
              category: 'text', // *必填* 内容类型 text：文本 
              text: '文旌课堂的目标是：助力教师轻松教学，助力学生高效学习。', // *必填* 文本内容
              textStyle: {
              },
            },
          ],
          textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
          },
        }
      ]
    },
    // 正文
    {
      key: 'section1.4', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section1.4.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '根植于教材研发业务，文旌课堂通过深入挖掘教学痛点和难点，为', // *必填* 文本内容
          textStyle: {
          },
        },
        {
          key: 'section1.4.2', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '2 000', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Times New Roman', // 字体，本地配置的字体
          },
        },
        {
          key: 'section1.4.3', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '多种纸质教材配备了免费的“', // *必填* 文本内容
          textStyle: {
          },
        },
        {
          key: 'section1.4.4', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '1', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Times New Roman', // 字体，本地配置的字体
          },
        },
        {
          key: 'section1.4.5', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '+', // *必填* 文本内容
          textStyle: {
          },
        },
        {
          key: 'section1.4.6', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '1', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Times New Roman', // 字体，本地配置的字体
          },
        },
        {
          key: 'section1.4.7', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '+', // *必填* 文本内容
          textStyle: {
          },
        },
        {
          key: 'section1.4.8', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: 'n', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Times New Roman', // 字体，本地配置的字体
            fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
          },
        },
        {
          key: 'section1.4.9', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '资源集合”（见图', // *必填* 文本内容
          textStyle: {
          },
        },
        {
          key: 'section1.4.10', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '2', // *必填* 文本内容
          textStyle: {
            fontFamily: 'Times New Roman', // 字体，本地配置的字体
          },
        },
        {
          key: 'section1.4.11', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: '），覆盖了“教” “学” “管” “考” “评”等核心教学环节。', // *必填* 文本内容
          textStyle: {
          },
        },
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        // color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 思维导图
    {
      key: 'section1.5', // *必填* 唯一标识
      type: 'mindMap', // *必填* 类型：思维导图
      content: {
        // 思维导图 的数据
        "data": {
          // "text":"1+1+n  资源集合"
          "text": "<span style=\"color: #fff\"><span style=\"font-family:'Times New Roman'\">1<\/span>+<span style=\"font-family:'Times New Roman'\">1<\/span>+<span style=\"font-family:'Times New Roman'; font-style: italic;\">n<\/span>资源集合<\/span>",
          "richText": true,
        },
        "children": [
          {
            "data": {
              "id":"section4",
              "text":"<span style=\"font-family:'Times New Roman'\">1<\/span>组五星级资料包",
              "richText": true,
            },
            "children":[
              {
                "data": {
                  "id":"e3ka7wjjre",
                  "text":"涵盖课前→课中→课后教师所需要的大部分教学资料；一体化设计，提供大量实用案例和拓展资料，融入有趣的互动元素，实用性高、互动性强。",
                  "richText": true,
                  "type":"highlight"
                }
              }
            ]
          },
          {
            "data": {
              "id":"section1",
              "text":"<span style=\"font-family:'Times New Roman'\">1<\/span>个教学管理平台",
              "richText": true,
            },
            "children":[
              {
                "data": {
                  "id":"section1.1",
                  "text":"文旌教学",
                  "richText": true,
                },
                "children":[
                  {
                    "data": {
                      "id":"0esa0jonr9er",
                      "text":"聚焦学生学习、教师教学、学校管理过程的在线教学管理平台，助力教学提质增效。",
                      "richText": true,
                    }
                  }
                ]
              }, 
              {
                "data": {
                  "id":"section1.2",
                  "text":"文旌考试",
                  "richText": true,
                },
                "children":[
                  {
                    "data": {
                      "id":"0esa0jonr3er",
                      "text":"聚焦职教高考和专升本考试的在线考试管理平台，帮助学生精准备考、教师高效教学。",
                      "richText": true,
                    }
                  }
                ]
              }
            ]
          },
          {
            "data": {
              "id":"section3",
              "text":"<span style=\"font-family:'Times New Roman'; font-style: italic;\">n<\/span>种教学小工具",
              "richText": true,
              "generalization": [{// （0.9.0以下版本不支持数组，只能设置单个概要数据）节点的概要，如果没有概要generalization设为null即可
                "text": '功能实用、使用便捷的教学小工具，能帮助学生整合学习资料，爱上自主学习；能辅助教师减少繁复性工作，提升教学效率。', // 概要的文本
                "richText": true, // 节点的文本是否是富文本模式
                // ...其他普通节点的字段都支持，但是不支持children
              }],
            },
            "children":[
              {
                "data": {
                  "id":"section3.1",
                  "text":"在线刷题宝",
                  "richText": true,
                }
              },
              {
                "data": {
                  "id":"section3.2",
                  "text":"<span style=\"font-family:'Times New Roman';\">App<\/span>背单词",
                  "richText": true,
                }
              },
              {
                "data": {
                  "id":"section3.3",
                  "text":"<span style=\"font-family:'Times New Roman';\">App<\/span>公式带背",
                  "richText": true,
                }
              },
              {
                "data": {
                  "id":"section3.4",
                  "text":"扫码布置作业",
                  "richText": true,
                }
              },
              {
                "data": {
                  "id":"section3.5",
                  "text":"扫码任务互评",
                  "richText": true,
                }
              }
            ]
          }
        ]
      },
      
      title: "图<span style=\"font-family:'Times New Roman'\">2<\/span>&nbsp;&nbsp;&nbsp;&nbsp;<span style=\"font-family:'Times New Roman'\">1<\/span>+<span style=\"font-family:'Times New Roman'\">1<\/span>+<span style=\"font-family:'Times New Roman'; font-style: italic;\">n<\/span>资源集合", // 标题\
      // width: 'xxxx', // 内容区域宽度 非必填 默认100%
      titleStyle: {

      }
    },
    // 视频
    {
      key: 'section1.6', // *必填* 唯一标识
      type: 'video', // *必填* 类型：视频
      templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
      content: [ // *必填* 视频列表
        {
          key: 'section1.6.1', // *必填* 唯一标识
          url: require("@/assets/video/文旌教学平台宣传片.mp4"), // *必填* 视频地址
          left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
          title: '教学管理平台——文旌教学', // 视频标题
          subtitle: '视频资源:', // 视频副标题 只在全部显示时使用
          titleStyle: {
            // 根据需要是否加标题样式
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
          }
        },
        
      ],
    },
    // 正文
    {
      key: 'section1.7', // *必填* 唯一标识
      type: 'text', // *必填* 类型：正文
      content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
        {
          key: 'section1.7.1', // *必填* 唯一标识
          category: 'text', // *必填* 内容类型 text：文本 
          text: ' 同时，我们自主研发了可听、可视、可练、可互动的数字教材产品，能够丰富教师教学资源和教学手段，激发学生的学习兴趣。', // *必填* 文本内容
          textStyle: {
          },
        },
      ],
      textStyle: {
        // fontFamily: 'xxx', // 字体，本地配置的字体
        // fontSize: 20, // 文字大小  默认：20
        // lineHeight: 40, // 行高  默认：36
        textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
        // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
        // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
        // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
        // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
        // color: '#333', // 文本颜色  默认：#00a8ac
        // backgroundColor: '#FFF', // 背景颜色  默认：无
      },
    },
    // 交互 连连看
    {
      key: 'section1.8', // *必填* 唯一标识
      type: 'action', // *必填* 类型：交互
      actionType: 1, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
      title: '连一连 请帮助吉祥物们找到属于自己的品牌。', // 标题
      titleStyle: {},
      isBlock: 1, // 是否默认存在一个区域框
      content: {
        // 连连看
        key: 'action1',
        info: '请拖动下方备选吉祥物，以完成左侧品牌和右侧吉祥物的一一对应。',
        leftData: [
          {
            key: 'action1.1',
            actionKey: 'action1',
            // title: 'Tencent',
            cover: require("@/assets/images/books/bookExample/connection-left-1.png"),
            answerKey: 'key1'
          },
          {
            key: 'action1.2',
            actionKey: 'action1',
            // title: 'Linux',
            cover: require("@/assets/images/books/bookExample/connection-left-2.png"),
            answerKey: 'key2'
          },
          {
            key: 'action1.3',
            actionKey: 'action1',
            // title: 'wenjingketang',
            cover: require("@/assets/images/books/bookExample/connection-left-3.png"),
            answerKey: 'key3'
          }
        ],
        rightData: [
          {
            key: 'action1.4',
            actionKey: 'action1',
            // title: 'Linux',
            cover: require("@/assets/images/books/bookExample/connection-right-2.png"),
            answerKey: 'key2'
          },
          {
            key: 'action1.5',
            actionKey: 'action1',
            // title: 'Tencent',
            cover: require("@/assets/images/books/bookExample/connection-right-1.png"),
            answerKey: 'key1'
          },
          {
            key: 'action1.6',
            actionKey: 'action1',
            // title: 'wenjingketang',
            cover: require("@/assets/images/books/bookExample/connection-right-3.png"),
            answerKey: 'key3'
          }
        ],

      },
    },
]
export default content